exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-list__error-text,.van-list__finished-text,.van-list__loading-text{color:#969799;font-size:13px;line-height:50px;text-align:center}.van-list__loading{text-align:center}.van-list__loading-icon,.van-list__loading-text{display:inline-block;vertical-align:middle}.van-list__loading-icon{width:16px;height:16px;margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vant/es/list/index.css
// module id = 228
// module chunks = 0